import classNames from "classnames/bind";
import styles from './RegisterVerifyContainer.module.css';
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import Button from "../../../components/Button/Button";
const cx = classNames.bind(styles)

function ErrorNotify({ backTo }) {
    const navigate = useNavigate()
    const handleBack = () => {
        navigate(backTo)
    }
    return (
        <div className={cx('error-container')}>
            <h1 className={cx('header-error')}>Bạn đã nhập quá số lần quy định</h1>
            <p className={cx('title-error')}>Trở về trang trước</p>
            <Link to={backTo} className={cx('button-back')}>
                <Button title={'Quay lại'} onClick={handleBack} />
            </Link>
        </div>
    )
}
ErrorNotify.propTypes = {
    backTo: PropTypes.string.isRequired
}
export default ErrorNotify